import { Component, OnInit, Input } from '@angular/core'
import { Observable } from 'rxjs'
import { DealConfigurationQuery } from 'generated/graphql'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'

@UntilDestroy()
@Component({
    selector: 'mg-checkout-referral-banner',
    templateUrl: './checkout-referral-banner.component.html',
    styleUrls: ['./checkout-referral-banner.component.scss'],
})
export class CheckoutReferralBannerComponent implements OnInit {
    emailAddress$: Observable<String>
    referralCode: String
    referralProgram: String

    @Input() deal$: Observable<DealConfigurationQuery['Deal']>

    ngOnInit(): void {
        this.deal$.pipe(untilDestroyed(this)).subscribe(deal => {
            this.referralCode = deal.referralCode || ''
            this.referralProgram = deal.referralProgram?.name || ''
        })
    }
}
